import * as Yup from "yup"
import { validString } from "Components/shared/helpers/validations"
import { reverseShape } from "Helpers/reverse-shape"

const VehicleInfoSchema = Yup.object().shape(
    reverseShape({
        parentOrgID: validString.required(),
        doesRiderOwnVehicle: validString.required(),
        vehicleCategory: Yup.mixed().when("doesRiderOwnVehicle", {
            is: "true",
            then: validString.oneOf(["ELECTRIC", "NORMAL"]).required(),
        }),
        vehicleType: Yup.mixed().when("doesRiderOwnVehicle", {
            is: "true",
            then: validString
                .oneOf(["CAR", "VAN", "LORRY", "MOTORCYCLE"])
                .required(),
        }),
        vehicleModel: Yup.mixed().when("doesRiderOwnVehicle", {
            is: "true",
            then: validString.required(),
        }),
        plateNumber: Yup.mixed().when("doesRiderOwnVehicle", {
            is: "true",
            then: validString.required(),
        }),
    })
)

export default VehicleInfoSchema
